module.exports = __webpack_public_path__ + "img/banner.a2ccf33b.png";